import { useEffect , useState , useRef } from "react";
import { useLocation } from "react-router-dom";

function SmsPolicy() {
    
    const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  
  const [showButton, setShowButton] = useState(false);
    const clickTimeoutRef = useRef(null);


    useEffect(() => {
        const handleScroll = () => {
            setShowButton(window.scrollY > 500);
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            setTimeout(() => {
                const target = document.querySelector(hash);
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
            }, 300);
        }
    }, []);

    const handleClick = () => {
        if (clickTimeoutRef.current) {
           
            clearTimeout(clickTimeoutRef.current);
            clickTimeoutRef.current = null;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
        
            clickTimeoutRef.current = setTimeout(() => {
                const target = document.querySelector('.other-privacy-content');
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
                clickTimeoutRef.current = null;
            }, 300);
        }
    };


  return (
    <>
    <main className="container-fluid p-0">  

    <section className="legal-container">
            <div className="legal-wrapper">
                <div className="legal-content-section">
                    <h1 className="card-title-xl fw-l">Text Messaging Policy</h1>
                </div>
                <div className="legal-image-container">
                    <img src="/assets/images/smspolicy.webp" alt="" style={{aspectRatio:"16/8"}}/>
                </div>
            </div>
        </section>  
        
        <section className="privacy-section mb-3" id="">
            <div className="other-privacy-content">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card " id="">
                        
                            <p className="xsmall mb-2">At Credence Resource Management, LLC. we believe in keeping our customers updated and satisfied with our
                                services. By opting in and providing your mobile number, you allow us to send you important account-related text
                                messages, such as payment reminders and notifications, directly to your phone.
                            </p>
                            <p className="xsmall mb-2">The number of messages may vary depending on your account and usage. We kindly request that you ensure you have
                                ownership rights or permission to use the number you provide.
                            </p>
                            <p className="xsmall mb-2">Please note that message and data rates may apply, and we advise that you check with your wireless carrier to understand their terms and conditions.</p>
                            <p className="xsmall mb-2">If you wish to opt out of receiving SMS messages from us, simply reply STOP any text message we send you. You will receive an opt-out confirmation message to acknowledge your request.</p>
                        
                            <p className="xsmall mb-2">You can also email us at <a href="mailto:customerservice@credencerm.com">
                                        customerservice@credencerm.com</a> for support. Our team is always available to assist you with any queries or concerns.</p>                        
                            <p className="xsmall mb-2">If your handset does not support MMS, any messages sent may be delivered as SMS messages.</p>
                            <p className="xsmall mb-2">Please note that wireless carriers are not liable for undelivered or delayed messages.</p>
                            <p className="xsmall mb-2">By opting in to receive text messages from Credence Resource Management, LLC. You acknowledge and
                                agree
                                to the terms and conditions of this policy. If you have any questions or concerns, please do not hesitate to
                                contact
                                Credence Resource Management, LLC’s customer support at <a href="tel:+1-855-880-4791"> +1-855-880-4791</a>
                            </p>
                        
                        </div>
                    </div>
                </div>
                
             </div>        
        </section>
    </main>
  
    <button
            id="scrollToTopBtn"
            className="scrollTopButton"
            aria-label="Scroll to top"
            style={{ display: showButton ? 'block' : 'none' }}
            onClick={handleClick}
        >
            <i className="bx bx-chevron-up"></i>
        </button>
    </>
  );
}

export default SmsPolicy;
